import React from 'react';
import { createRoot } from 'react-dom/client';

import { FAQAccordion } from '@shared/FAQAccordion';
import { getFaqTheoryAccess } from '../main-app/data/faq-theory-access';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-faq-accordion');

  if (!node) return;

  const schoolName = node.getAttribute('data-school-name');
  const theoryProvider = node.getAttribute('data-theory-provider-name');
  const city = node.getAttribute('data-city');
  const street = node.getAttribute('data-street');
  const zipcode = node.getAttribute('data-zipcode');
  const phone = node.getAttribute('data-school-phone');

  const root = createRoot(node);
  root.render(<FAQAccordion faqList={getFaqTheoryAccess(schoolName, theoryProvider, city, street, zipcode, phone)} />);
});
